export const doctorTypes = {
    FETCHING_MORE_DOCTORS_PAGE: "FETCHING_MORE_DOCTORS_PAGE",
    GET_DOCTORS_LIST: "GET_DOCTORS_LIST",
    REQUEST_DOCTORS_PAGE: "REQUEST_DOCTORS_PAGE",
    SEARCH_FOR_DOCTOR: "SEARCH_FOR_DOCTOR",
    FETCHING_MORE_FOLLOWED_DOCTORS_PAGE: "FETCHING_MORE_FOLLOWED_DOCTORS_PAGE",
    REQUEST_AUTH_FOLLOWED_DOCTORS_PAGE: "REQUEST_AUTH_FOLLOWED_DOCTORS_PAGE",
    GET_DOCTOR_DETAILS: "GET_DOCTOR_DETAILS",
    CURRENT_DOCTOR_NOT_FOUND: "CURRENT_DOCTOR_NOT_FOUND",
    GET_DOCTOR_BRANCHES: "GET_DOCTOR_BRANCHES",
    GET_BRANCH_DAYS: "GET_BRANCH_DAYS",
    CLEAR_CURRENT_DAY: "CLEAR_CURRENT_DAY",
    GET_BRANCH_DAY_TIMES: "GET_BRANCH_DAY_TIMES",
    GET_BRANCH_DAY_BREAKS: "GET_BRANCH_DAY_BREAKS",
    GET_CURRENT_BOOKING_FEES_DETAILS: "GET_CURRENT_BOOKING_FEES_DETAILS",
    GET_CURRENT_BOOKING_ERROR: "GET_CURRENT_BOOKING_ERROR",
    GET_CITIES_LIST: "GET_CITIES_LIST",
    FETCHING_MORE_REVIEWS: "FETCHING_MORE_REVIEWS",
    GET_DOCTOR_REVIEWS: "GET_DOCTOR_REVIEWS",
    NO_MORE_REVIEWS: "NO_MORE_REVIEWS",
    CLEAR_REVIEWS: "CLEAR_REVIEWS",
    CLEAR_BOOKING_INFO: "CLEAR_BOOKING_INFO",
    CLEAR_DOCTOR_LIST: "CLEAR_DOCTOR_LIST",
    CLEAR_CURRENT_DOCTOR: "CLEAR_CURRENT_DOCTOR",
    GET_SEARCH_DATA: "GET_SEARCH_DATA",
    SET_SEARCH_DATA: "SET_SEARCH_DATA",
    CLEAR_SEARCH_DATA: "CLEAR_SEARCH_DATA",
    GO_TO_DOCTOR_PROFILE_FROM_BOOKING: "GO_TO_DOCTOR_PROFILE_FROM_BOOKING",
    SEARCH_FROM_FOOTER: "SEARCH_FROM_FOOTER",
};